// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"2df5d649","505":"e46383ee","533":"33e5a3ee","546":"349d9b06","899":"4cef4c07"}[chunkId] + ".chunk.css";
};